export class FeedbackModel {
    feedbackDescription?: string;
    userId?: string;
    menuId?: string;
    hospitalCode?: string;
    hospitalName?: string;
    createBy?: string;
}
